var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.321 26.8697C8.3107 26.1152 5.83797 24.3636 3.90278 21.6149C1.96759 18.8663 1 15.8535 1 12.5767V4.88045L11.321 1L21.642 4.88045V12.5767C21.642 15.8535 20.6744 18.8662 18.7392 21.6149C16.804 24.3636 14.3313 26.1152 11.321 26.8697Z",
    fill: "#ECFFF6",
    stroke: "#1F9F60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1891 17.0073L15.8449 11.3515L14.9256 10.4521L10.1891 15.1886L7.79093 12.7904L6.8916 13.6897L10.1891 17.0073Z",
    fill: "#1F9F60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationSuccessIcon);
export default __webpack_public_path__ + "static/media/verification-success-icon.dc290b8100fc5556d37b053d76990593.svg";
export { ForwardRef as ReactComponent };